import { GRAPHQL } from '../../../cms/constants';
import { PERK_QUERY } from '../../../cms/queries';

const PERKS = `
  ... on MemberPerk {
    ${PERK_QUERY}
  }
`;

const PERKS_FOR_OFFER_PAGE = `
  ... on MemberPerk {
    slogan
    name
    ${GRAPHQL.IMAGE_OBJECT}
    ${GRAPHQL.RELEASE}
    ${GRAPHQL.URL_OBJECT}
  }
`;

const ANNOUNCEMENTS = `
  ... on BrandCampaign {
    ${GRAPHQL.ID}
    ${GRAPHQL.TYPE}
    name
    sloganRaw
    descriptionRaw
    ${GRAPHQL.IMAGE_OBJECT}
    ${GRAPHQL.URL_OBJECT}
  }
  ... on ComplianceIncident {
    ${GRAPHQL.ID}
    ${GRAPHQL.TYPE}
    name
    descriptionRaw
    ${GRAPHQL.IMAGE_OBJECT}
    ${GRAPHQL.URL_OBJECT}
  }
  ... on ExternalContent {
    ${GRAPHQL.ID}
    ${GRAPHQL.TYPE}
    identifier {
      current
    }
    title
  }
  ... on Legislation {
    ${GRAPHQL.ID}
    ${GRAPHQL.TYPE}
    name
    descriptionRaw
    ${GRAPHQL.IMAGE_OBJECT}
    ${GRAPHQL.URL_OBJECT}
  }
  ... on ProductListSection {
    title
    ${GRAPHQL.ID}
    ${GRAPHQL.TYPE}
    productLists {
      __typename
      ... on ProductList {
        productType
        productIdsCouple
        productIdsSingle
        productIdsFamily
        productIdsSingleParent
        ${GRAPHQL.URL_OBJECT}
      }
    }
  }
  ... on PromotionalCtaList {
    name
    ${GRAPHQL.ID}
    ${GRAPHQL.TYPE}
    items {
      ... on Service {
        _id
        ${GRAPHQL.CONTENT_TILE_FIELDS}
        ${GRAPHQL.IMAGE_OBJECT}
      }
    }
  }
  ... on QuestionsList {
    title
    questions {
      ... on Question {
        _id
        question
        answerRaw
      }
    }
  }
  ... on SalesJourney {
    ${GRAPHQL.ID}
    ${GRAPHQL.TYPE}
    name
    descriptionRaw
    ${GRAPHQL.IMAGE_OBJECT}
    ${GRAPHQL.URL_OBJECT}
  }
  ... on UnmodelledAnnouncement {
    ${GRAPHQL.ID}
    ${GRAPHQL.TYPE}
    name
    sloganRaw
    descriptionRaw
    ${GRAPHQL.IMAGE_OBJECT}
    ${GRAPHQL.URL_OBJECT}
  }
  ... on ServiceChannel {
    ${GRAPHQL.ID}
    ${GRAPHQL.TYPE}
    name
    sloganRaw
    descriptionRaw
    ${GRAPHQL.IMAGE_OBJECT}
    installUrlObjects {
      name
      url
      ${GRAPHQL.IMAGE}
    }
  }
  ... on ValuePropositionGroup {
    ${GRAPHQL.ID}
    ${GRAPHQL.TYPE}
    descriptionRaw
    title
    valuePropositions {
      sloganRaw: name
      summaryRaw
      ${GRAPHQL.URL_OBJECT}
      ${GRAPHQL.IMAGE_OBJECT}
    }
  }
`;

const AWARDS = `
   ... on Award {
    ${GRAPHQL.IMAGE_OBJECT}
  }
`;

const WHY_AHM = `
  ... on ValuePropositionGroup {
    ${GRAPHQL.ID}
    ${GRAPHQL.TYPE}
    description: descriptionRaw
    name: title
    valuePropositionsReference: valuePropositions {
      name
      slogan: sloganRaw
      summary: summaryRaw
      ${GRAPHQL.URL_OBJECT}
      ${GRAPHQL.IMAGE_OBJECT}
    }
  }
`;

const CONTACTS = `
  ... on Contact {
    action
    descriptionRaw
    name
    phoneNumber
    title
    type
  }
`;

const FEATURED_ARTICLE = `
  ... on Article {
    _createdAt
    bodyRaw
    name
    insuranceType {
      ${GRAPHQL.SLUG}
    }
    ${GRAPHQL.SLUG}
    descriptionRaw
    tags {
     name
    }
    ${GRAPHQL.IMAGE_OBJECT}
  }
`;

const ANNOUNCEMENT_BY_INSURANCE_TYPE = `
  ... on Alert {
    name
    descriptionRaw
    level
  }
`;

export const FRAGMENTS = {
  ANNOUNCEMENTS,
  ANNOUNCEMENT_BY_INSURANCE_TYPE,
  AWARDS,
  CONTACTS,
  FEATURED_ARTICLE,
  PERKS,
  PERKS_FOR_OFFER_PAGE,
  WHY_AHM,
};

export const SLUG = {
  AWARDS: 'ahm-awards',
  CONTACT_MEMBER_BANNER: 'contact-member-banner',
  CURRENT_MEMBER_CONTACTS: 'current-member-contacts',
  FEATURED_ARTICLE: 'featured-article',
  LOOKING_TO_JOIN_CONTACTS: 'looking-to-join-contacts',
  WHY_AHM: 'why-ahm',
};
